import React from "react";
import { useTheme } from "../config/ThemeContext";

function TimeoutDisplay({ isTimeoutActive, timeoutDuration, timeoutType, timeoutTeamName }) {
  const theme = useTheme();

  if (!isTimeoutActive || !timeoutDuration) return null;

  const isTechnical = timeoutType === "TECHNICAL";
  const progress = ((30 - timeoutDuration) / 30) * 100;
  const isWarning = timeoutDuration <= 10;
  const isCritical = timeoutDuration <= 5;

  const getDisplayTitle = () => {
    if (isTechnical) {
      return "🛠 Technical Timeout";
    }
    return `⏱ Team Timeout – ${timeoutTeamName}`;
  };

  const getProgressColor = () => {
    if (isCritical) return "from-red-500 to-red-600";
    if (isWarning) return "from-yellow-500 to-orange-500";
    return "from-blue-500 to-indigo-600";
  };

  const getBackgroundColor = () => {
    if (isCritical) return "bg-red-50 border-red-200";
    if (isWarning) return "bg-yellow-50 border-yellow-200";
    return "bg-blue-50 border-blue-200";
  };

  return (
    <div className="fixed bottom-4 left-1/2 transform -translate-x-1/2 z-50 animate-in slide-in-from-bottom-4">
      <div className={`
        rounded-xl shadow-lg border p-4 min-w-[300px]
        ${getBackgroundColor()}
      `}>
        {/* Title */}
        <div className="text-lg font-bold mb-2 text-gray-800">
          {getDisplayTitle()}
        </div>

        {/* Timer */}
        <div className="text-3xl font-bold mb-3 text-center">
          {timeoutDuration}s
        </div>

        {/* Progress Bar */}
        <div className="h-2 rounded-full bg-gray-200 overflow-hidden">
          <div
            className={`h-full rounded-full bg-gradient-to-r ${getProgressColor()}`}
            style={{ width: `${progress}%`, transition: "width 1s linear" }}
          />
        </div>
      </div>
    </div>
  );
}

export default TimeoutDisplay;
